export default "__VITE_ASSET__CaUydFOu__"